import {
  fetchV1Products,
  createV1Product,
  searchV1Products,
  fetchV1ProductVariants,
  fetchV1ProductVariant,
  createV1ProductVariants,
  editV1ProductVariant,
  createV1ProductWithVariant,
} from "@/services/v1/inventoryAPIService";

export default {
  state: {
    // product
    products: [],
    productPageSize: 5,
    totalProductCount: 0,
    productSearhQuery: "",
    // variant
    productVariants: [],
    productVariant: null,
    productVariantPageSize: 5,
    totalProductVariantCount: 0,
  },
  getters: {
    // product
    products: (state) => state.products,
    currentProductPageSize: (state) => state.productPageSize,
    totalProductCount: (state) => state.totalProductCount,
    productSearhQuery: (state) => state.productSearhQuery,
    // variant
    productVariants: (state) => state.productVariants,
    productVariant: (state) => state.productVariant,
    currentProductVariantPageSize: (state) => state.productVariantPageSize,
    totalProductVariantCount: (state) => state.totalProductVariantCount,
  },
  mutations: {
    // product
    SET_PRODUCTS(state, products) {
      state.products = products;
    },
    SET_PRODUCT_PAGE_SIZE(state, pageSize) {
      state.productPageSize = pageSize;
    },
    SET_TOTAL_PRODUCTS_COUNT(state, count) {
      state.totalProductCount = count;
    },
    SET_PRODUCT_SEARCH_QUERY(state, query) {
      state.productSearhQuery = query;
    },
    // variants
    SET_PRODUCT_VARIANTS(state, productVariants) {
      state.productVariants = productVariants;
    },
    SET_PRODUCT_VARIANT(state, productVariant) {
      state.productVariant = productVariant;
    },
    SET_PRODUCT_VARIANT_PAGE_SIZE(state, pageSize) {
      state.productVariantPageSize = pageSize;
    },
    SET_TOTAL_PRODUCT_VARIANTS_COUNT(state, count) {
      state.totalProductVariantCount = count;
    },
    UPDATE_PRODUCT_VARAINT(state, updatedProduct) {
      const index = state.productVariants.findIndex(
        (p) => p.sku === updatedProduct.sku
      );

      if (index !== -1) {
        state.productVariants[index] = {
          ...state.productVariants[index],
          ...updatedProduct,
        };
      }
    },
  },
  actions: {
    // product
    async fetchProducts({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Products(page, pageSize);
        commit("SET_PRODUCTS", response.results);
        commit("SET_PRODUCT_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_PRODUCTS_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchProducts({ commit }, { query, page = 1, pageSize = 8 } = {}) {
      commit("SET_PRODUCT_SEARCH_QUERY", query);
      try {
        const response = await searchV1Products(query, page, pageSize);
        commit("SET_PRODUCTS", response.results);
        commit("SET_PRODUCT_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_PRODUCTS_COUNT", response.count);
      } catch (error) {
        console.error("Error searching categories:", error);
      }
    },
    async addProduct({ commit }, product) {
      try {
        const response = await createV1Product(product);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`product create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Product.";
        return { success: false, message };
      }
    },
    async addProductWithVariant({ commit }, data) {
      try {
        const response = await createV1ProductWithVariant(data);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`product create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Product.";
        return { success: false, message };
      }
    },
    // variants
    async fetchProductVariants({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1ProductVariants(page, pageSize);
        commit("SET_PRODUCT_VARIANTS", response.results);
        commit("SET_PRODUCT_VARIANT_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_PRODUCT_VARIANTS_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching products variants:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async fetchProductVariant({ commit }, sku) {
      commit("SET_PRODUCT_VARIANT", null);
      try {
        const response = await fetchV1ProductVariant(sku);
        commit("SET_PRODUCT_VARIANT", response);
      } catch (error) {
        console.error("Error fetching variant:", error);
        // const errorMessages = [];
        // for (const [key, value] of Object.entries(error.response.data)) {
        //   errorMessages.push(value);
        //   console.log(`Book fetch... ${key}: ${value}`);
        // }
        // commit("SET_BOOK_ERROR", errorMessages);
      } finally {
        // commit("SET_BOOK_LOADING", false);
        console.log("finally...");
      }
    },
    async addVariant({ commit }, product) {
      try {
        const response = await createV1ProductVariants(product);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`product create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Product.";
        return { success: false, message };
      }
    },
    async editProductVariant({ commit }, { sku, data }) {
      try {
        const response = await editV1ProductVariant(sku, data);
        commit("SET_PRODUCT_VARIANT", response);
        commit("UPDATE_PRODUCT_VARAINT", response);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`product create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Product.";
        return { success: false, message };
      }
    },
  },
};
